var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"currency-symbol flex flex--align-center flex--justify-center",style:({
        backgroundColor: _vm.backgroundColor,
        borderColor: _vm.borderColor,
    })},[_c('span',{staticClass:"currency-symbol__symbol",style:({
            color: _vm.color,
            '--fontSize-mobile': _vm.fontSize[0],
            '--fontSize-web': _vm.fontSize[1]
        })},[_vm._v(" "+_vm._s(_vm.symbol)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }